import React, { createContext, useContext, useState, useEffect } from 'react';

const DEFAULT_CONFIG = {
  companyName: 'DotoniWoof',
  legalID: '901.981.483-0',
  address: 'Cra 22 g # 59 a - 31',
  tagline: 'El mejor cuidado para tu mejor amigo',
  logoUrl: '/logo.jpg',
  loginImageUrl: null,
  faviconUrl: '/favicon.ico',
  colors: {
    primary: '#ffde59',
    secondary: '#EA9D0E',
    accent: '#332E5A',
    success: '#31a184',
    danger: '#ff3131',
    warning: '#ffde59',
    info: '#17a2b8'
  }
};

const BrandingContext = createContext(DEFAULT_CONFIG);

export const useBranding = () => useContext(BrandingContext);

const applyCssVariables = (colors) => {
  const root = document.documentElement;
  if (!colors) return;
  root.style.setProperty('--tenant-primary', colors.primary || DEFAULT_CONFIG.colors.primary);
  root.style.setProperty('--tenant-secondary', colors.secondary || DEFAULT_CONFIG.colors.secondary);
  root.style.setProperty('--tenant-accent', colors.accent || DEFAULT_CONFIG.colors.accent);
  root.style.setProperty('--tenant-success', colors.success || DEFAULT_CONFIG.colors.success);
  root.style.setProperty('--tenant-danger', colors.danger || DEFAULT_CONFIG.colors.danger);
  root.style.setProperty('--tenant-warning', colors.warning || DEFAULT_CONFIG.colors.warning);
  root.style.setProperty('--tenant-info', colors.info || DEFAULT_CONFIG.colors.info);
};

export const BrandingProvider = ({ children }) => {
  const [config, setConfig] = useState(DEFAULT_CONFIG);

  useEffect(() => {
    fetch('/config.json')
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error('Config not found'))))
      .then((data) => {
        const merged = {
          companyName: data.companyName ?? DEFAULT_CONFIG.companyName,
          legalID: data.legalID ?? DEFAULT_CONFIG.legalID,
          address: data.address ?? DEFAULT_CONFIG.address,
          tagline: data.tagline ?? DEFAULT_CONFIG.tagline,
          logoUrl: data.logoUrl ?? DEFAULT_CONFIG.logoUrl,
          loginImageUrl: data.loginImageUrl ?? DEFAULT_CONFIG.loginImageUrl,
          faviconUrl: data.faviconUrl ?? DEFAULT_CONFIG.faviconUrl,
          colors: {
            primary: data.colors?.primary ?? DEFAULT_CONFIG.colors.primary,
            secondary: data.colors?.secondary ?? DEFAULT_CONFIG.colors.secondary,
            accent: data.colors?.accent ?? DEFAULT_CONFIG.colors.accent,
            success: data.colors?.success ?? DEFAULT_CONFIG.colors.success,
            danger: data.colors?.danger ?? DEFAULT_CONFIG.colors.danger,
            warning: data.colors?.warning ?? DEFAULT_CONFIG.colors.warning,
            info: data.colors?.info ?? DEFAULT_CONFIG.colors.info
          }
        };
        setConfig(merged);
        applyCssVariables(merged.colors);
        // Actualizar favicon dinámicamente
        const faviconEl = document.querySelector('link[rel="shortcut icon"], link[rel="icon"]');
        if (faviconEl && merged.faviconUrl) {
          faviconEl.href = merged.faviconUrl.startsWith('/') ? merged.faviconUrl : merged.faviconUrl;
        }
        // theme-color para PWA
        const themeColorEl = document.querySelector('meta[name="theme-color"]');
        if (themeColorEl && merged.colors?.primary) {
          themeColorEl.setAttribute('content', merged.colors.primary);
        }
      })
      .catch(() => {
        applyCssVariables(DEFAULT_CONFIG.colors);
      });
  }, []);

  return (
    <BrandingContext.Provider value={config}>
      {children}
    </BrandingContext.Provider>
  );
};

export default BrandingContext;
